// Only this client's exact session key is migrated or cleared; other clients' keys are untouched.
export function createAuthStorage(local: Storage, session: Storage, storageKey: string) {
  const modeKey = `${storageKey}.persistence`;
  const persistent = () => session.getItem(modeKey) !== 'session' && local.getItem(modeKey) === 'local';
  const target = () => persistent() ? local : session;
  return {
    storage: {
      getItem: (key: string) => target().getItem(key),
      setItem: (key: string, value: string) => target().setItem(key, value),
      removeItem: (key: string) => target().removeItem(key),
    },
    choose(keepConnected: boolean) {
      // Called after signing out the current local session, before signing in the requested account.
      for (const key of [storageKey, `${storageKey}-code-verifier`, `${storageKey}-user`]) {
        local.removeItem(key); session.removeItem(key);
      }
      session.setItem(modeKey, keepConnected ? 'local' : 'session');
      if (keepConnected) local.setItem(modeKey, 'local'); else local.removeItem(modeKey);
    },
  };
}
